import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  addAllCustomList,
  addListItemsToCart,
  // bulkInsertionProductCategories,
  getListItemsAction,
  updateCustomList,
  deleteCustomList,
  updateShoppedItem,
  substituteShopItem,
  getShoppingCartItems,
  addOrUpdateListItemsToCart
} from "./actions";

interface ShoppingList {
  isLoading: boolean;
  isError: boolean;
  userData: UserData;
  listName: string;
  listId: string;
  isAuthenticated:boolean;
  updatedAt: string;
  shoppingListProducts: {
    products: Product[];
    custom: CustomItem[];
  };
  errorMessage: string;
  substituteListData: SubstituteItem[];
  previousState?: ShoppingList; // Added for rollback in optimistic updates

}

export interface SubstituteItem {
  currentProductID: string;
  substituteProductID: string;
}

interface Product {
  id: number;
  name: string;
  quantity: number;
  is_favourite:number;
  item_id?: string;
  meta?:string
}

interface CustomItem {
  id: string;
  description: string;
}

interface UserData {
  userId: string;
  categoryId: string;
}

const initialState: ShoppingList = {
  isLoading: false,
  isError: false,
  userData: {
    userId: "",
    categoryId: "",
  },
  listName: "",
  shoppingListProducts: {
    products: [],
    custom: [],
  },
  listId: "",
  isAuthenticated:false,
  updatedAt: "",
  errorMessage: "",
  substituteListData:[],
};

const fallbackErrorMessage = ""

export const shoppingListSlice = createSlice({
  name: "shoppingListSlice",
  initialState,
  reducers: {
    resetShoppingList: () => initialState,

    setShoppingListData: (state, action) => {
      state.userData.categoryId = action.payload.categoryId;
      state.listName = action.payload.listName;
      state.shoppingListProducts.products = action.payload.products;
      state.shoppingListProducts.custom = action.payload.custom;
      state.listId=action.payload.listId
      state.isAuthenticated=action.payload.isAuthenticated
      state.updatedAt=action.payload.updatedAt
      state.isLoading = false

    },
    setItemListData: (state, action) => {
      if (!Array.isArray(state.shoppingListProducts)) {
        state.shoppingListProducts.products = [
          ...state.shoppingListProducts.products,
        ];
        state.shoppingListProducts.custom = [
          ...state.shoppingListProducts.custom,
        ];
      }
      if (action.payload) {
        if (action.payload?.items[0]?.product_type == "Custom") {
          state.shoppingListProducts.custom = [
            ...state.shoppingListProducts.custom,
            action.payload?.items[0],
          ];
        } else if (action.payload?.items[0]?.product_type == "Product") {
          const existingIndex = state.shoppingListProducts.products.findIndex(
            (item: any) => item.item_id == action.payload?.items[0]?.item_id 
          );
          if (existingIndex !== -1) {
            if(action.payload?.items[0]?.quantity==0)
            {
              state.shoppingListProducts.products =state.shoppingListProducts.products.filter(
                (item:any) => item.item_id != action.payload?.items[0]?.item_id 
              );

              return;
            }
            state.shoppingListProducts.products[existingIndex] = action.payload?.items[0];
          } else {
            state.shoppingListProducts.products.push(action.payload?.items[0]);
          }
        }
      }
    },
    setCustomManageList: (state, action) => {
      
      if (!Array.isArray(state.shoppingListProducts)) {
        state.shoppingListProducts.products = [
          ...state.shoppingListProducts.products,
        ];
        state.shoppingListProducts.custom = [
          ...state.shoppingListProducts.custom,
        ];
      }
      if (action.payload) {
        if (action.payload?.items[0]?.product_type == "Custom") {
          state.shoppingListProducts.custom = [
            ...state.shoppingListProducts.custom,
            action.payload?.items[0],
          ];
        }
      }
    },
    renameCustomMangementList: (state, action) => {
      if (!Array.isArray(state.shoppingListProducts)) {
        state.shoppingListProducts.products = [
          ...state.shoppingListProducts.products,
        ];
        state.shoppingListProducts.custom = [
          ...state.shoppingListProducts.custom,
        ];
      }
      // state.shoppingListProducts.custom = state.shoppingListProducts.custom.map(
      //   (item: any) => {
      //     if (action.payload?.items[0]?.quantity > 0 && item.item_id == action.payload?.items[0]?.item_id ) {
      //       return {
      //         ...item,
      //         meta: action.payload?.items[0]?.meta,
      //         quantity: action.payload?.items[0]?.quantity
      //       };
      //     }
      //     return item;
          
      //   }
      // );
      // if(action.payload?.items[0]?.quantity == 0){
      //   state.shoppingListProducts.custom =
      //   state.shoppingListProducts.custom.filter(
      //     (item:any) => item.item_id != action.payload?.items[0]?.item_id
      //   );
      // }
      

      const items = action.payload?.items || [];

      items.forEach((updateItem: any) => {
        if (updateItem.product_type === "Custom") {
          if (updateItem.quantity > 0) {
            // Update matching item in custom
            state.shoppingListProducts.custom = state.shoppingListProducts.custom.map(
              (item: any) =>
                item.item_id == updateItem.item_id
                  ? { ...item, meta: updateItem.meta, quantity: updateItem.quantity }
                  : item
            );
          } else {
            // Remove if quantity is zero
            state.shoppingListProducts.custom = state.shoppingListProducts.custom.filter(
              (item: any) => item.item_id != updateItem.item_id
            );
          }
        }

        if (updateItem.product_type === "Product") {
          if (updateItem.quantity > 0) {
            state.shoppingListProducts.products = state.shoppingListProducts.products.map(
              (item: any) =>
                item.item_id == updateItem.item_id+"_"+action.payload?.storeId
                  ? { ...item, meta: updateItem.meta, quantity: updateItem.quantity }
                  : item
            );
          } else {
            state.shoppingListProducts.products = state.shoppingListProducts.products.filter(
              (item: any) => item.item_id != updateItem.item_id+"_"+action.payload?.storeId
            );
          }
        }
      });

    },
    deleteCustomManageList: (state, action: PayloadAction<{ id: string }>) => {
      console.log("kkkkkkkkk", action.payload);
      if (!Array.isArray(state.shoppingListProducts)) {
        state.shoppingListProducts.products = [
          ...state.shoppingListProducts.products,
        ];
        state.shoppingListProducts.custom = [
          ...state.shoppingListProducts.custom,
        ];
      }
      state.shoppingListProducts.custom =
        state.shoppingListProducts.custom.filter(
          (item:any) => item.itemId !== action.payload?.id
        );
    },
    setIsShopped: (state, action:PayloadAction<any>) => {
      if (!Array.isArray(state.shoppingListProducts)) {
        state.shoppingListProducts.products = [
          ...state.shoppingListProducts.products,
        ];
        state.shoppingListProducts.custom = [
          ...state.shoppingListProducts.custom,
        ];
      }

      const isShoped = action.payload?.is_shopped==0?1:0;

      if (action.payload?.listType === "Custom") {
        state.shoppingListProducts.custom = state.shoppingListProducts.custom.map((item: any) => {
          if (item.itemId === action.payload?.itemId) {
            return { ...item, is_shopped:isShoped};
          }
          return item;
        });
      } else {
        state.shoppingListProducts.products = state.shoppingListProducts.products.map((item: any) => {
          if (item.item_id === action.payload?.item_id) {
            return { ...item, is_shopped:isShoped};
          }
          return item;
        });
      }
    },
    resetUserData: (state) => {
      state.userData = { userId: "", categoryId: "" };
    },
    updateShoppingList: (state, action) => {
      if (!Array.isArray(state.shoppingListProducts)) {
        state.shoppingListProducts.products = [
          ...state.shoppingListProducts.products,
        ];
      }
      if (action.payload) {
            if(action.payload?.quantity==0)
            {
              state.shoppingListProducts.products =state.shoppingListProducts.products.filter(
                (item:any) => item.item_id != action.payload.itemId 
              );

              return;
            }else {
              state.shoppingListProducts.products = state.shoppingListProducts.products.map(
                (item: any) => {
                  if (item.item_id == action.payload?.itemId) {
                    // If the item matches the id, update its name
                    return {
                      ...item,
                      quantity: action.payload?.quantity
                    };
                  }
                  return item;
                }
              );
            }
         
        
      }
    },

    deleteFavouriteProduct: (state, action) => {
      state.shoppingListProducts.products = state.shoppingListProducts.products.filter(
        (item: Product) =>  item?.item_id != action.payload
      );
    },

    subtituteProductFromShopList: (state, action) => {
      const substitutions = action?.payload;
    
      if (Array.isArray(substitutions)) {
        substitutions.forEach(({ currentProductID, substituteProductID }) => {
          const existingIndex = state?.shoppingListProducts?.products?.findIndex(
            (item: any) => item?.item_id === currentProductID
          );
    
          if (existingIndex !== -1) {
            state.shoppingListProducts.products[existingIndex].item_id = substituteProductID;
            state.shoppingListProducts.products[existingIndex].meta = ""; 
          }
        });
      }
    },
    
    

    setShoppingMessage: (state) => {
      state.errorMessage = "";
    },

    updateShoppingListByStore: (state, action)  => {
      state.shoppingListProducts.products = action.payload ?? [];
    },

    setSubstituteListData: (state, action) => {
      const { currentProductID, substituteProductID } = action.payload || {};

      if (!currentProductID || !substituteProductID) return;

      if (!Array.isArray(state.substituteListData)) {
        state.substituteListData = [];
      }

      const existingIndex = state?.substituteListData?.findIndex(
        (item) => item.currentProductID === currentProductID
      );

      if (existingIndex !== -1) {
        const existingItem = state.substituteListData[existingIndex];
        if (existingItem.substituteProductID === substituteProductID) {
          state.substituteListData = state.substituteListData.filter(
            (item) =>
              !(
                item.currentProductID === currentProductID &&
                item.substituteProductID === substituteProductID
              )
          );
        } else {
          state.substituteListData[existingIndex].substituteProductID =
            substituteProductID;
        }
      } else {
        state.substituteListData.push({
          currentProductID,
          substituteProductID,
        });
      }
    },

    clearSubstitute:(state)=>{
      state.substituteListData=[];

    },
    
    updateListName:(state, action)=>{
      state.listName=action.payload;
    },

    resetProductData: (state) => {
      state.shoppingListProducts.products = [];
    },

  },
  extraReducers: (builder) => {
    //bulk insertion management list
    // builder.addCase(bulkInsertionProductCategories.pending, (state: any) => {
    //   state.isLoading = true;
    //   state.isError = false;
    // });
    // builder.addCase(bulkInsertionProductCategories.fulfilled, (state: any) => {
    //   state.isLoading = false;
    //   state.isError = false;
    //   state.isAuthenticated=true
    // });
    // builder.addCase(bulkInsertionProductCategories.rejected, (state: any, action) => {
    //   state.isLoading = false;
    //   state.isError = true;
    //   state.errorMessage = action?.payload ?? fallbackErrorMessage;
    // });

    // Get list items
    builder.addCase(getListItemsAction.pending, (state: any) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(getListItemsAction.fulfilled, (state: any, action) => {
      state.isLoading = false;
      state.isError = false;
      if(action.payload?.data){
        state.shoppingListProducts.products = [
          ...(action.payload?.data?.items ?? []).filter(
            (val: { type: string }) => val.type == "Product"
          ),
        ];
        
        state.shoppingListProducts.custom = [
          ...(action.payload?.data?.items ?? []).filter(
            (val: { type: string }) => val.type == "Custom"
          ),
        ];
        state.userData.user_id = action.payload.data.user_id;
        state.userData.id = action.payload.data.id;
        state.listName = action.payload.data.name;
        state.listId = action.payload.data.id;
        state.is_active = action.payload.data.is_active
        state.isAuthenticated=true,
        state.updatedAt=action.payload.data.updatedAt
      }
    });
    builder.addCase(getListItemsAction.rejected, (state: any, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action?.payload ?? fallbackErrorMessage;
    });

    // Add item
    builder.addCase(addListItemsToCart.pending, (state: any, action) => {
      state.isLoading = true;
      state.isError = false;
       // Store previous state for rollback
// debugger
state.previousState = {
  ...state,
  shoppingListProducts: {
    products: [...state.shoppingListProducts.products],
    custom: [...state.shoppingListProducts.custom],
  },
};

// Optimistically update state
if (action.meta.arg?.listType == "Custom") {
  state.shoppingListProducts.custom = [
    ...state.shoppingListProducts.custom,
    action.meta.arg,
  ];
} else if (action.meta.arg?.listType == "Product") {
  const existingIndex = state.shoppingListProducts.products.findIndex(
    (item: any) => item.item_id == action.meta.arg?.itemId
  );

  if (existingIndex !== -1) {
    state.shoppingListProducts.products[existingIndex] = {
      ...state.shoppingListProducts.products[existingIndex],
      quantity: action.meta.arg?.quantity,
    };

  } else {
    const itemData = {
      item_id: action.meta.arg?.itemId,
      type: action.meta.arg?.listType,
      quantity: action.meta.arg?.quantity,
    }

    state.shoppingListProducts.products = [
      ...state.shoppingListProducts.products,
      itemData,
    ];
  }
}
    });
    builder.addCase(
      addListItemsToCart.fulfilled,
      (state: any, action: PayloadAction<any>) => {
        if (!Array.isArray(state.shoppingListProducts)) {
          state.shoppingListProducts.products = [
            ...state.shoppingListProducts.products,
          ];
          state.shoppingListProducts.custom = [
            ...state.shoppingListProducts.custom,
          ];
        }
        state.isLoading = false;
        state.isError = false;
        state.isAuthenticated=true
        if(action.payload?.resultData?.type == "Product"){
          state.listName = action.payload?.listName;
          state.listId = action.payload.category_id;
        }
        if (action.payload) {
          if (action.payload?.resultData?.type == "Custom") {
            state.shoppingListProducts.custom = [
              ...state.shoppingListProducts.custom,
              action.payload.resultData,
            ];
          } else {
            if (action?.payload?.resultData) {
              state.shoppingListProducts.products =state.shoppingListProducts.products.map((item: any) => {
            if (item.item_id == action?.payload?.resultData?.item_id) {
              return {
                ...item,
                id: action?.payload?.resultData?.id,
                category_id: action?.payload?.resultData?.category_id,
                updatedAt: action?.payload?.resultData?.updatedAt,
              }
            }
           
            return item;
          });
          // if (!state.shoppingListProducts.products.some((item: {id: string}) => item.id == action?.payload?.resultData?.id)) {
          //   state.shoppingListProducts.products = [
          //     ...state.shoppingListProducts.products,
          //     action?.payload?.resultData,
          //   ];
          // }
              }

              else if(action?.payload?.deletedId)
              {
                state.shoppingListProducts.products =state.shoppingListProducts.products.filter(
                      (item:any) => item.id != action.payload?.deletedId
                    );

              }
            else{
              state.shoppingListProducts.products = [
                ...state.shoppingListProducts.products,
                action?.payload?.resultData,
              ];
            }
          }
        }
      }
    );
    builder.addCase(addListItemsToCart.rejected, (state: any, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action?.payload ?? fallbackErrorMessage;
    });

    //update item
    builder.addCase(updateCustomList.pending, (state: any) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(
      updateCustomList.fulfilled,
      (state: any, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isError = false;
        state.isAuthenticated=true
        state.shoppingListProducts.custom =
          state.shoppingListProducts.custom.map((item: any) => {
            if (item.id == action?.payload?.itemData?.id) {
              // If the item matches the id, update its name
              return {
                ...item,
                meta: action?.payload?.itemData?.meta,
                quantity: action?.payload?.itemData?.quantity
              };
            }
            return item;
          });
      }
    );
    builder.addCase(updateCustomList.rejected, (state: any, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action?.payload ?? fallbackErrorMessage;
    });

    //bulk insertion for custom  list
    builder.addCase(addAllCustomList.pending, (state: any) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(addAllCustomList.fulfilled, (state: any) => {
      state.isLoading = false;
      state.isError = false;
      state.isAuthenticated=true
    });
    builder.addCase(addAllCustomList.rejected, (state: any, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action?.payload ?? fallbackErrorMessage;
    });

   

    //Delete Custom List Item
    builder.addCase(deleteCustomList.pending, (state: any) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(deleteCustomList.fulfilled, (state: any,action: PayloadAction<any>) => {
      state.isLoading = false;
      state.isError = false;
      state.isAuthenticated=true
      state.shoppingListProducts.custom = state.shoppingListProducts.custom.filter((item:any)=>item.id != action.payload?.id)
    });
    builder.addCase(deleteCustomList.rejected, (state: any, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action?.payload ?? fallbackErrorMessage;
    });

    //SetIsShopped List Item
    builder.addCase(updateShoppedItem.pending, (state: any) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(updateShoppedItem.fulfilled, (state: any,action: PayloadAction<any>) => {
      state.isLoading = false;
      state.isError = false;
      state.isAuthenticated=true

      if(action?.payload?.getListData?.type==="Custom")
      {
        state.shoppingListProducts.custom =
        state.shoppingListProducts.custom.map((item: any) => {
          if (item.id === action?.payload?.getListData?.id) {
            return {
              ...item,
              is_shopped: action?.payload?.getListData?.is_shopped,
            };
          }
          return item;
        });
      }
      else
      {
        state.shoppingListProducts.products =
        state.shoppingListProducts.products.map((item: any) => {
          if (item.id === action?.payload?.getListData?.id) {
            return {
              ...item,
              is_shopped: action?.payload?.getListData?.is_shopped,
            };
          }
          return item;
        });
      }
      
    });
    builder.addCase(updateShoppedItem.rejected, (state: any, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action?.payload ?? fallbackErrorMessage;
    });

    //Substitute Products
    builder.addCase(substituteShopItem.pending, (state: any) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(substituteShopItem.fulfilled, (state: any,action: PayloadAction<any>) => {
      state.isLoading = false;
      state.isError = false;
      state.isAuthenticated=true;


      if (action?.payload) {

        const { currentProduct, substituteProduct } = action.payload;


        const existingIndex = state?.shoppingListProducts?.products?.findIndex(
          (item: any) => item?.item_id === currentProduct?.item_id
        );
        if (existingIndex !== -1) {
          state.shoppingListProducts.products[existingIndex].item_id =
          substituteProduct?.item_id;
        }

      }
      
    });
    builder.addCase(substituteShopItem.rejected, (state: any, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action?.payload ?? fallbackErrorMessage;
    });


      // Get Cart list items
      builder.addCase(getShoppingCartItems.pending, (state: any) => {
        state.isLoading = true;
        state.isError = false;
      });
      builder.addCase(getShoppingCartItems.fulfilled, (state: any, action) => {
        state.isLoading = false;
        state.isError = false;
        //debugger
        if(action.payload?.data){
          state.shoppingListProducts.products = [
            ...(action.payload?.data?.items ?? []).filter(
              (val: { product_type: string }) => val.product_type == "Product"
            ),
          ];
          
          state.shoppingListProducts.custom = [
            ...(action.payload?.data?.items ?? []).filter(
              (val: { product_type: string }) => val.product_type == "Custom"
            ),
          ];
          // state.userData.user_id = action.payload.data.user_id;
          // state.userData.id = action.payload.data.id;
          // state.listName = action.payload.data.name;
          // state.listId = action.payload.data.id;
          // state.is_active = action.payload.data.is_active
          state.isAuthenticated=true
          // state.updatedAt=action.payload.data.updated_at
        }
      });
      builder.addCase(getShoppingCartItems.rejected, (state: any, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action?.payload ?? fallbackErrorMessage;
      });


       // Add item
    builder.addCase(addOrUpdateListItemsToCart.pending, (state: any, action) => {
      state.isLoading = true;
      state.isError = false;
       // Store previous state for rollback
     

    // Optimistically update state
    if (action.meta.arg?.items?.[0]?.product_type == "Product") {
      state.previousState = {
        ...state,
        shoppingListProducts: {
          products: [...state.shoppingListProducts.products],
          custom: [...state.shoppingListProducts.custom],
        },
      };
      const existingIndex = state.shoppingListProducts.products.findIndex(
        (item: any) => item.item_id == action.meta.arg?.items?.[0]?.item_id+"_"+action.meta.arg?.storeId
      );

      if (existingIndex !== -1 && action.meta.arg?.items?.[0]?.quantity > 0) {
        state.shoppingListProducts.products[existingIndex] = {
          ...state.shoppingListProducts.products[existingIndex],
          quantity: action.meta.arg?.items?.[0]?.quantity,
        };

      } else if(action.meta.arg?.items?.[0]?.quantity == 0) {

        state.shoppingListProducts.products =state.shoppingListProducts.products.filter(
          (item:any) => item?.item_id != action.meta.arg?.items?.[0]?.item_id+"_"+action.meta.arg?.storeId
        );
      }
      else {
        if(action.meta.arg?.items?.[0]?.product_type == "Product"){
          const itemData = {
            item_id: action.meta.arg?.items?.[0]?.item_id+"_"+action.meta.arg?.storeId,
            type: action.meta.arg?.items?.[0]?.product_type,
            quantity: action.meta.arg?.items?.[0]?.quantity,
          }

          state.shoppingListProducts.products = [
            ...state.shoppingListProducts.products,
            itemData,
          ];
        }
      }
    }

    if (action.meta.arg?.items?.[0]?.product_type == "Custom") {
      state.previousState = {
        ...state,
        shoppingListProducts: {
          products: [...state.shoppingListProducts.products],
          custom: [...state.shoppingListProducts.custom],
        },
      };
       if(action.meta.arg?.items?.[0]?.quantity == 0) {

        state.shoppingListProducts.custom =state.shoppingListProducts.custom.filter(
          (item:any) => item?.id != action.meta.arg?.items?.[0]?.id
        );
      }
     
    }
    });
    builder.addCase(
      addOrUpdateListItemsToCart.fulfilled,
      (state: any, action: PayloadAction<any>) => {
        
        const newItems = action.payload?.data || [];
        if (!Array.isArray(state.shoppingListProducts)) {
          state.shoppingListProducts.products = [...state.shoppingListProducts.products];
          state.shoppingListProducts.custom = [...state.shoppingListProducts.custom];
        }
        state.previousState = undefined; // Clear previous state
        newItems.forEach((item: any) => {
          if (item.product_type == "Product") {
            const index = state.shoppingListProducts.products.findIndex(
              (p: any) => p.item_id == item.item_id
            );

            if (index > -1) {
              const { quantity, ...rest } = item; 
              state.shoppingListProducts.products[index] = {
                ...state.shoppingListProducts.products[index],
                ...rest
              };
            } else {
              state.shoppingListProducts.products.push(item);
            }
          }

          if (item.product_type == "Custom") {
            const index = state.shoppingListProducts.custom.findIndex(
              (c: any) => c.id == item.id
            );

            if (index > -1) {
              // Update existing
              state.shoppingListProducts.custom[index] = {
                ...state.shoppingListProducts.custom[index],
                ...item
              };
            } else {
              // Add new
              state.shoppingListProducts.custom.push(item);
            }
          }
        });

        const deleteIds: string[] = action.payload?.deleteItemIds || [];

        if(newItems.length == 0 && Array.isArray(deleteIds) && deleteIds.length > 0){
          state.shoppingListProducts.custom = state.shoppingListProducts.custom.filter(
            (item: any) => !deleteIds.includes(item.id)
          );
        
          state.shoppingListProducts.products = state.shoppingListProducts.products.filter(
            (item: any) => !deleteIds.includes(item.id)
          );
        }
      }
       
    );
    builder.addCase(addOrUpdateListItemsToCart.rejected, (state: any, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action?.payload ?? fallbackErrorMessage;
      if (state.previousState) {
        state.shoppingListProducts.products =
          state.previousState.shoppingListProducts.products;
          state.shoppingListProducts.custom =
          state.previousState.shoppingListProducts.custom;
        state.previousState = undefined;
      }
    });

  },
});

export const {
  setShoppingListData,
  setItemListData,
  resetUserData,
  renameCustomMangementList,
  setIsShopped,
  deleteCustomManageList,
  resetShoppingList,
  updateShoppingList,
  deleteFavouriteProduct,
  subtituteProductFromShopList,
  setShoppingMessage,
  updateShoppingListByStore,
  setSubstituteListData,
  clearSubstitute,
  updateListName,
  setCustomManageList,
  resetProductData
} = shoppingListSlice.actions;
export const shoppingListSliceReducer = shoppingListSlice.reducer;